import { logUsage } from "owa-analytics";
import type { MailboxInfo } from "owa-client-types";

const Prefix = "data:image/";
const Base64 = ";base64,";
const PrefixLength = 11; // Length of "data:image/"
const ContentTypeStartIndex = 5; // Length of "data:"
const Base64Length = 8; // Length of ";base64,"
// we need to replace the content type in case it's invalid
const normalizedContentType = new Map<string, string>([["image/jpg", "image/jpeg"]]);

export function parseDataUri(source: string): {
    dataUri: string;
    contentType: string;
} | null {
    const base64Index = source.indexOf(Base64);
    
    if (source.startsWith(Prefix) && base64Index > PrefixLength) {
        let contentType = source.substring(ContentTypeStartIndex, base64Index);
        const dataUri = source.substring(ContentTypeStartIndex + contentType.length + Base64Length);
        const correctContentType = normalizedContentType.get(contentType);
        if (correctContentType) {
            contentType = correctContentType;
        }
        return { contentType, dataUri };
    }
    else {
        return null;
    }
}

export default function createFileFromImageSource(source: string, mailboxInfo: MailboxInfo): File | null {
    let file: File | null = null;
    
    const parseResult = parseDataUri(source);
    
    if (parseResult) {
        const { contentType, dataUri } = parseResult;
        let byteString: string | null = null;
        
        try {
            byteString = atob(dataUri);
        }
        catch (error) {
            /* eslint-disable owa-custom-rules/forbid-specific-functions-on-catch-finally-blocks, owa-custom-rules/telemetry-event-name-format -- (https://aka.ms/OWALintWiki)
             * BASELINE. DO NOT COPY AND PASTE!, replace this line with a justification or fix the error, use PerformanceDatapoint instead.
             * undefined
             *	> Do not call 'logUsage' from 'owa-analytics' inside catch or finally blocks
             (https://aka.ms/OWALintWiki)
                         * Baseline. DO NOT COPY AND PASTE! Grandfathering existing event names; Devs who touch this file should update Event Names to follow Outlook Telemetry Naming Standards
                         *	> Invalid Outlook telemetry EventName "createFileFromImageSource": must start with a capital letter (A–Z). */
            
            // Errors resulting from enabling useUnknownInCatchVariables
            // TS18046: 'error' is of type 'unknown'.
            // @ts-expect-error
            logUsage("createFileFromImageSource", mailboxInfo, [error.message]);
            /* eslint-enable owa-custom-rules/forbid-specific-functions-on-catch-finally-blocks, owa-custom-rules/telemetry-event-name-format  */
        }
        
        if (byteString) {
            const arrayBuilder = new ArrayBuffer(byteString.length);
            const unit8Array = new Uint8Array(arrayBuilder);
            
            for (let i = 0; i < byteString.length; i++) {
                unit8Array[i] = byteString.charCodeAt(i);
            }
            
            file = new File([arrayBuilder], "image.png", { type: contentType });
        }
    }
    else {
        /* eslint-disable-next-line owa-custom-rules/telemetry-event-name-format -- (https://aka.ms/OWALintWiki)
         * Baseline. DO NOT COPY AND PASTE! Grandfathering existing event names; Devs who touch this file should update Event Names to follow Outlook Telemetry Naming Standards
         *	> Invalid Outlook telemetry EventName "createFileFromImageSource": must start with a capital letter (A–Z). */
        logUsage("createFileFromImageSource", mailboxInfo, ["Fail to parse source url"]);
    }
    
    return file;
}
